const STORAGE_KEY = "recital-master.audio-feed.v1";

export function readPersistedAudioFeedId() {
  try {
    return typeof localStorage === "undefined" ? null : localStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
}

export function persistAudioFeedId(id: string) {
  try {
    if (typeof localStorage !== "undefined") localStorage.setItem(STORAGE_KEY, id);
  } catch {
    // Playback preference persistence is best-effort.
  }
}

/**
 * A media pipeline can briefly report its authored default before it finishes
 * applying the user's durable feed choice. Never let that transient report
 * replace the preference that is still being negotiated.
 */
export function acceptedReportedAudioFeedId(
  reportedId: string | null,
  preferredId: string | null
) {
  if (!reportedId) return null;
  return !preferredId || reportedId === preferredId ? reportedId : null;
}
